import { TranslateService } from "./translate.service";

/* to load and set en.json as the default application language */
export function setupTranslateFactory(service: TranslateService) {
    return () => service.use("en");
  }